"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var colors = _interopRequireWildcard(require("../colors"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//   As of v. 2.x, react-select no longer provides internal components with unique classNames that can be used to apply custom styles.
//   Instead, the following style tags may be used to apply additional styles using css-in-js.
//   For further details, please consult https://react-select.com/styles
//
//   Style tags:
//   clearIndicator
//   container
//   control
//   dropdownIndicator
//   group
//   groupHeading
//   indicatorsContainer
//   indicatorSeparator
//   input
//   loadingIndicator
//   loadingMessage
//   menu
//   menuList
//   menuPortal
//   multiValue
//   multiValueLabel
//   multiValueRemove
//   noOptionsMessage
//   option
//   placeholder
//   singleValue
//   valueContainer
var styles = {
  clearIndicator: function clearIndicator() {
    return {
      display: 'inline-block',
      fontSize: '20px',
      lineHeight: 1,
      animation: 'Select-animation-fadeIn 200ms',
      cursor: 'pointer',
      width: '20px',
      alignSelf: 'center',
      zIndex: 3,
      color: colors.teal.base,
      '&:hover': {
        color: colors.teal.darker
      }
    };
  },
  control: function control(base, state) {
    return {
      backgroundColor: state.isDisabled ? colors.silver : colors.white,
      borderColor: colors.alloy,
      borderRadius: '2px',
      border: "1px solid ".concat(colors.alloy),
      color: colors.cobalt.base,
      cursor: 'default',
      display: 'flex',
      borderSpacing: 0,
      borderCollapse: 'separate',
      outline: 'none',
      overflow: 'hidden',
      position: 'relative',
      width: '100%'
    };
  },
  dropdownIndicator: function dropdownIndicator(base, state) {
    var disabledStyles = {
      cursor: 'default',
      pointerEvents: 'none',
      opacity: 0.35
    };
    var defaultStyles = {
      cursor: 'pointer',
      position: 'relative',
      color: colors.teal.base,
      border: 'none',
      height: 'auto',
      marginRight: '17px',
      fontSize: '18px',
      fontFamily: 'FontAwesome',
      transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : null
    };
    return state.isDisabled ? _objectSpread({}, defaultStyles, {}, disabledStyles) : defaultStyles;
  },
  indicatorSeparator: function indicatorSeparator() {
    return {};
  },
  input: function input(base, state) {
    return {
      height: '42px',
      paddingLeft: '6px',
      paddingRight: '16px',
      verticalAlign: 'middle',
      '& div': {
        paddingRight: '16px',
        verticalAlign: 'middle',
        minWidth: '10px',
        background: 'none transparent',
        boxShadow: 'none',
        display: 'inline-block',
        fontFamily: 'inherit',
        fontSize: 'inherit',
        margin: state.isMulti ? '0 0 0 10px' : 0,
        outline: 'none',
        lineHeight: '25px',
        padding: state.isMulti ? 0 : '16px 0'
      },
      '& div:focus': {
        cursor: 'text'
      }
    };
  },
  menu: function menu() {
    return {
      borderBottomRightRadius: '4px',
      borderBottomLeftRadius: '4px',
      backgroundColor: colors.white,
      border: "1px solid ".concat(colors.alloy),
      boxSizing: 'border-box',
      marginTop: '-1px',
      maxHeight: '305px',
      overflowY: 'auto',
      position: 'absolute',
      top: '100%',
      width: '100%',
      zIndex: 6,
      webkitOverflowScrolling: 'touch'
    };
  },
  multiValue: function multiValue(base, state) {
    var isDisabled = state.isDisabled;
    var backgroundColor = isDisabled ? colors.silver : colors.horizon;
    var color = isDisabled ? colors.alloy : colors.shale;
    return {
      marginLeft: '9px',
      marginTop: '21px',
      backgroundColor: backgroundColor,
      border: "1px solid ".concat(colors.alloy),
      borderRadius: '2px',
      color: color,
      display: 'flex',
      fontSize: '0.9em',
      lineHeight: 1.4,
      verticalAlign: 'top'
    };
  },
  multiValueLabel: function multiValueLabel() {
    return {
      display: 'inline-block',
      verticalAlign: 'middle',
      borderBottomRightRadius: '2px',
      borderTopRightRadius: '2px',
      cursor: 'default',
      padding: '2px 5px'
    };
  },
  multiValueRemove: function multiValueRemove(base, state) {
    var isDisabled = state.isDisabled;
    var cursor = isDisabled ? 'not-allowed' : 'pointer';
    var borderRight = isDisabled ? "1px solid ".concat(colors.alloy) : null;
    return {
      cursor: cursor,
      borderRight: borderRight,
      borderBottomLeftRadius: '2px',
      borderTopLeftRadius: '2px',
      padding: '1px 5px 3px',
      color: state.isFocused ? colors.teal.darker : colors.teal.base,
      fontSize: '14px',
      fontWeight: 'bold',
      '&:hover': {
        color: colors.teal.darker
      }
    };
  },
  noOptionsMessage: function noOptionsMessage() {
    return {
      boxSizing: 'border-box',
      color: colors.slate,
      cursor: 'default',
      display: 'block',
      padding: '12px 10px'
    };
  },
  option: function option(base, state) {
    var isDisabled = state.isDisabled,
        isFocused = state.isFocused,
        isSelected = state.isSelected;
    var disabledBackgroundColor = isDisabled ? colors.silver : null;
    var disabledColor = isDisabled ? colors.alloy : null;
    var focusedBackgroundColor = isFocused ? '#f8fafc' : null;
    var selectedBackgroundColor = isSelected ? colors.horizon : null;
    var baseBackgroundColor = '#fff';
    var backgroundColor = disabledBackgroundColor || selectedBackgroundColor || focusedBackgroundColor || baseBackgroundColor;
    var baseColor = colors.teal.base;
    var focusedColor = isFocused ? colors.teal.darker : null;
    var color = disabledColor || focusedColor || baseColor;
    var cursor = isDisabled ? 'default' : 'pointer';
    return {
      boxSizing: 'border-box',
      backgroundColor: backgroundColor,
      color: color,
      cursor: cursor,
      display: 'block',
      padding: '12px 10px 12px 16px',
      '&:last-child': {
        borderBottomRightRadius: '4px',
        borderBottomLeftRadius: '4px'
      }
    };
  },
  placeholder: function placeholder() {
    return {
      bottom: 0,
      color: colors.slate,
      left: 0,
      lineHeight: '48px',
      paddingLeft: '16px',
      paddingRight: '16px',
      position: 'absolute',
      right: 0,
      top: 0,
      maxWidth: '100%',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    };
  },
  singleValue: function singleValue() {
    return {
      bottom: 0,
      left: 0,
      lineHeight: '48px',
      padding: '10px 16px 0px 16px',
      position: 'absolute',
      right: 0,
      top: 0,
      maxWidth: '100%',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    };
  }
};
var _default = styles;
exports["default"] = _default;